import { render, staticRenderFns } from "./WaitingListLocalTraining.vue?vue&type=template&id=12442038&"
import script from "./WaitingListLocalTraining.js?vue&type=script&lang=js&"
export * from "./WaitingListLocalTraining.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports